import React, { useState, useEffect } from 'react'
import Combobox from "@shared/combobox"

import { getRequest } from '@react/helpers/fetch'
import { pathname } from '@react/helpers/fetch'

const initialState = {
  supplier:        {},
  purchaseInvoice: {}
}
const PurchaseInvoiceSelect = ({ data }) => {
  const [state, setState] = useState(initialState)

  const { supplierFieldName, purchaseInvoiceFieldName } = data

  const fetchSupplier = (supplierId, purchaseInvoiceId) => {
    setState(initialState)
    if (supplierId) {
      const path = "/suppliers/:id/build".replace(":id", supplierId)
      const format = 'json'
      const url = pathname({ path, format })
      getRequest(url).then(supplier => {
        if (purchaseInvoiceId) {
          const purchaseInvoice = supplier.purchase_invoices.find(pi => pi.id == purchaseInvoiceId) || {}
          setState({ supplier, purchaseInvoice })
        } else {
          setState({ supplier, purchaseInvoice: {} })
        }
      })
    }
  }

  useEffect(() => {
    if (data.supplierId) {
      fetchSupplier(data.supplierId, data.purchaseInvoiceId)
    }
  }, [])

  const {supplier, purchaseInvoice} = state

  return (
    <>
      <div className="form-group">
        <label>{I18n.t("purchase_invoices.supplier")}</label>
        <Combobox
          options         = {data.suppliers}
          value           = {supplier.id}
          onSelectElement = {supplier => fetchSupplier(supplier.id)}
          prompt          = {I18n.t("purchase_invoices.select_supplier")}
          fieldName       = {supplierFieldName}
        />
      </div>

      <div className="form-group">
        <label>{I18n.t("purchase_invoices.purchase_invoice")}</label>
        <Combobox
          options   = {supplier.purchase_invoices || []}
          value     = {purchaseInvoice.id}
          prompt    = {I18n.t("purchase_invoices.select_purchase_invoice")}
          fieldName = {purchaseInvoiceFieldName}
        />
      </div>
    </>
  )
}

export default PurchaseInvoiceSelect
